import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Button as MuiButton } from '@mui/material';
export const Button = /*#__PURE__*/ forwardRef(function Button({ size = 'medium', variant = 'primary', isDanger = false, children, StartIcon, EndIcon, ...props }, ref) {
    // Map the variant option supplied to the appropriate MUI Button props
    const variantProps = getVariantProps(isDanger, variant);
    return /*#__PURE__*/ _jsx(MuiButton, {
        ...props,
        ...variantProps,
        startIcon: StartIcon,
        endIcon: EndIcon,
        ref: ref,
        size: size,
        children: children
    });
});
function getVariantProps(isDanger, variant) {
    // Map from our variant options to the MUI variant options
    const variantMap = {
        primary: {
            variant: 'contained',
            color: isDanger ? 'error' : 'primary'
        },
        secondary: {
            variant: 'outlined',
            color: isDanger ? 'error' : 'secondary'
        },
        tertiary: {
            variant: 'text',
            color: isDanger ? 'error' : 'primary'
        }
    };
    return variantMap[variant];
}

//# sourceMappingURL=Button.js.map